<template>
    <div class="flex-row c-app align-items-center">
        <CContainer>
            <CRow class="justify-content-center">
                <CCol md="12">
                    <CCardGroup>
                        <CCard class="p-4">
                            <CCardHeader>Доставка цветов</CCardHeader>
                            <CCardBody>
                                <CDataTable
                                    hover
                                    :items="items"
                                    :fields="fields"
                                    :items-per-page="100"
                                >
                                    <template #id="data">
                                        <td>
                                            #{{ data.item.order.id }}
                                        </td>
                                    </template>
                                    <template #price="data">
                                        <td>
                                            {{ data.item.order.price }}
                                        </td>
                                    </template>
                                    <template #status="data">
                                        <td>
                                            <CBadge
                                                :style="orderStatusStyle(data.item.order.status, data.item.order.type, data.item.order.payment_type)"
                                            >&nbsp;{{
                                                orderStatusTitle(data.item.order.status, data.item.order.type, data.item.order.payment_type, data.item.order.delivery_type)
                                            }}&nbsp;</CBadge
                                            >
                                        </td>
                                    </template>
                                    <template #customer="data">
                                        <td>
                                            {{
                                                data.item.order.customer.phone +
                                                    " " +
                                                    data.item.order.customer.firstname +
                                                    " " +
                                                    data.item.order.customer.lastname
                                            }}
                                        </td>
                                    </template>
                                    <template #comment="data">
                                        <td>{{ data.item.order.comment ? data.item.order.comment : "" }}</td>
                                    </template>
                                    <template #created_at="data">
                                        <td>{{ formatDate(data.item.order.created_at) }}</td>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                        </CCard>
                    </CCardGroup>
                </CCol>
            </CRow>
        </CContainer>
    </div>
</template>

<script>
    import Vue from 'vue';
    const {
        orderStatusTitle,
        orderStatusStyle,
        orderTypeTitle,
    } = require('../../utils/order-views');
    const { formatDate } = require('../../utils/views');

    export default {
        name: 'OrdersFDExternal',

        data() {
            return {
                hash: '',
                items: [],
                fields: [
                    { key: 'id', label: 'ID', _classes: 'font-weight-bold' },
                    { key: 'status', label: 'Статус' },
                    { key: 'customer', label: 'Клиент' },
                    { key: 'price', label: 'Цена' },
                    { key: 'comment', label: 'Комментарий' },
                    { key: 'created_at', label: 'Создан' },
                ],
            };
        },

        mounted() {
            this.hash = this.$route.query.hash;
            Vue.axios
                .get('/external/fd/' + this.hash)
                .then(resp => {
                    this.items = resp.data;
                })
                .catch(err => {
                    this.$router.push('/profile');
                });
        },
        methods: {
            updateStatus: function () {},
            orderStatusTitle(orderStatusId, orderType, paymentType, deliveryType) {
                return orderStatusTitle(orderStatusId, orderType, paymentType, null, deliveryType);
            },
            orderStatusStyle(orderStatusId, orderType, paymentType) {
                return orderStatusStyle(orderStatusId, orderType, paymentType);
            },
            orderTypeTitle(orderTypeId) {
                return orderTypeTitle(orderTypeId);
            },
            formatDate(ISOString) {
                return formatDate(ISOString);
            },
        },
    };
</script>
